import React, { Fragment } from 'react';
import { Cta } from './Cta';
import { Reveal } from './Reveal';
import { motion } from 'framer-motion';
import { useScore } from './ScoreContext';
const withoutSteps = ['Book creates trust', 'Generic next step', 'Reader stays invisible'];
const withSteps = ['Book creates trust', 'Useful reader step', 'Reader raises hand', 'You see what they cared about'];
export function MechanismVisual() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const ctaLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  const handleCtaClick = () => {
    openDiagnostic();
  };
  return <section className="py-28 md:py-44 bg-navy text-white relative overflow-hidden" data-id="element-273" data-mp="vryoii2bzyd">
      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-274" data-mp="1xoblt2xpnuog">
        <Reveal data-id="element-275" data-mp="1xpv2guna47qr">
          <p className="text-center text-xs font-semibold uppercase tracking-[0.25em] text-seaglass-light mb-6" data-id="element-276" data-mp="1xqemqi0ej87y">
            The mechanism
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-center mb-20 md:mb-28 text-paper leading-[1.1] tracking-[-0.01em]" data-id="element-277" data-mp="2nk25ewwg3cmo">
            What changes when there is <br className="hidden md:block" data-id="element-278" data-mp="2ir912a4w26b4" />
            <span className="italic text-seaglass-light" data-id="element-279" data-mp="2esjtwzag1kzx">
              a path behind the book
            </span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-10 mb-20 items-stretch" data-id="element-280" data-mp="29qazrzlu4cw8">
          {/* WITHOUT — muted, fading, unknown outcome */}
          <Reveal delay={0.1} data-id="element-281" data-mp="32gt9hjh2dcim">
            <div className="relative rounded-3xl p-8 md:p-10 border border-white/10 bg-white/[0.03] h-full flex flex-col" data-id="element-282" data-mp="32hksluth5hs0">
              <div className="flex justify-center mb-10" data-id="element-283" data-mp="2xk2rgqlp86uk">
                <span className="px-5 py-2 rounded-full text-sm font-bold uppercase tracking-[0.18em] text-gray-200 border border-white/15 bg-white/10" data-id="element-284" data-mp="2shu20481bmx7">
                  Without a path
                </span>
              </div>

              <div className="flex-1 flex flex-col items-center justify-start gap-0" data-id="element-285" data-mp="1h2f5f1jqmx2m">
                {withoutSteps.map((step, idx) => <Fragment key={idx} data-id="element-286" data-mp="1nk041pudaxbp" data-mpi={idx}>
                    <div className="w-full max-w-xs bg-navy-light/50 text-gray-300 py-4 px-5 rounded-xl border border-white/10 text-center text-base md:text-lg opacity-60" data-id="element-287" data-mp="1nixdxk4vcywu">
                      {step}
                    </div>
                    <div className="h-7 w-px border-l border-dashed border-gray-500 opacity-60" data-id="element-288" data-mp="1ehh2ra68csrk"></div>
                  </Fragment>)}
                <div className="w-16 h-16 rounded-full border-2 border-dashed border-gray-500 flex items-center justify-center text-gray-300 text-2xl font-serif" data-id="element-289" data-mp="14l4a8fmf8kye">
                  ?
                </div>
                <div className="mt-4 text-base font-semibold text-gray-200 uppercase tracking-[0.14em]" data-id="element-290" data-mp="uvb1dmdnyjxu">
                  Unknown outcome
                </div>
              </div>

              <p className="text-center text-gray-400 mt-10 text-sm leading-relaxed max-w-xs mx-auto" data-id="element-291" data-mp="gxmnwzlxef2t">
                The reader may have cared. They may have needed help. You still
                do not know what happened.
              </p>
            </div>
          </Reveal>

          {/* WITH — confident, sea-glass path, sand doorway */}
          <Reveal delay={0.2} data-id="element-292" data-mp="c7ak216s4ptt">
            <div className="relative rounded-3xl p-8 md:p-10 bg-paper text-navy border-2 border-seaglass h-full flex flex-col shadow-[0_30px_60px_-20px_rgba(0,0,0,0.5)]" data-id="element-293" data-mp="c8llhucr5lhr">
              <div className="flex justify-center mb-10" data-id="element-294" data-mp="l6njs253q01c">
                <span className="px-5 py-2 rounded-full text-sm font-bold uppercase tracking-[0.18em] text-white bg-seaglass" data-id="element-295" data-mp="g8m29lnbq8rz">
                  With a path
                </span>
              </div>

              <div className="flex-1 flex flex-col items-center justify-start gap-0" data-id="element-296" data-mp="pyfcai7tifu4">
                {withSteps.map((step, idx) => <Fragment key={idx} data-id="element-297" data-mp="13xot9k3uldz5" data-mpi={idx}>
                    <div className={`w-full max-w-xs py-4 px-5 rounded-xl text-center text-base md:text-lg font-medium z-10 ${idx === 1 ? 'bg-seaglass/15 border border-seaglass text-navy' : 'bg-white border border-gray-200 shadow-sm text-navy'}`} data-id="element-298" data-mp="13yq4ppos02he">
                    
                      {step}
                    </div>
                    <motion.div initial={{
                  height: 0
                }} whileInView={{
                  height: 28
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.4,
                  delay: 0.3 + idx * 0.2
                }} className="w-1.5 bg-seaglass rounded-full my-1" data-id="element-299" data-mp="2ycc301pld1rd">
                  </motion.div>
                  </Fragment>)}

                {/* Sand doorway = final destination */}
                <div className="w-full max-w-xs border-4 border-sand rounded-[1.75rem] bg-sand/15 pt-7 pb-5 text-center z-10" data-id="element-300" data-mp="2kdcdysy62kuo">
                  <div className="font-serif text-xl md:text-2xl font-bold text-sand-dark" data-id="element-301" data-mp="3vtt015487zqi">
                    Better-fit next step
                  </div>
                </div>
              </div>

              <p className="text-center text-text-muted mt-10 text-sm leading-relaxed font-medium max-w-xs mx-auto" data-id="element-302" data-mp="1o819c5i422a2">
                The reader gets a useful way forward. You get a clearer picture
                of what they may need.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.35} data-id="element-303" data-mp="1agnqkts118g3">
          <div className="text-center max-w-3xl mx-auto" data-id="element-304" data-mp="1ahfnc7xd1c7y">
            <p className="text-2xl md:text-3xl font-serif text-paper leading-snug mb-10" data-id="element-305" data-mp="1aetf062nasoo">
              "Not every reader needs to be sold.{' '}
              <br className="hidden md:block" data-id="element-306" data-mp="10hezq9sgk9xy" />
              <span className="italic text-seaglass-light" data-id="element-307" data-mp="10kt57qwf4z9m">
                Some need a useful step that keeps the relationship moving.
              </span>
              "
            </p>
            <Cta variant="primary" showArrow onClick={handleCtaClick} className="px-11 py-5 text-xl shadow-[0_14px_34px_-10px_rgba(212,165,116,0.6)] hover:-translate-y-0.5" data-id="element-308" data-mp="rjuz932f6hoe">
              
              {ctaLabel}
            </Cta>
          </div>
        </Reveal>
      </div>
    </section>;
}